<template><div><h1 id="fakturen-avis-aufbereitung-starten" tabindex="-1"><a class="header-anchor" href="#fakturen-avis-aufbereitung-starten"><span>Fakturen/Avis-Aufbereitung starten</span></a></h1>
<p>Fakturen/Avis-Aufbereitung starten — Fakturiert resp. avisiert Aufträge</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<h3 id="ablauf-der-fakturierung-und-avisierung" tabindex="-1"><a class="header-anchor" href="#ablauf-der-fakturierung-und-avisierung"><span>Ablauf der Fakturierung und Avisierung</span></a></h3>
<p>Die Aufbereitungsjobs arbeiten alle nach dem gleichen Pinzip. Ein Job betrachtet alle Aufträge, die den angegebenen Auftrags- und Verarbeitungsart(en) entsprechen. Für jeden einzelnen Auftrag prüft das System, ob es etwas tun muss. Je nach Verfügbarkeit der Artikel, den Einstellungen in den Geduldstufen und anderen Parametertabellen wird dann eine bestimmte Aktion ausgeführt: Avisierung (Information für den Kunden über den Lieferengpass) oder (Teil-)Lieferung. Beide Aktionen können mit der Absage-Aktion kombiniert werden.</p>
<p>Für einen Auftrag wird immer zuerst die Fakturierung wirksam; ein Auftrag, bei dem nicht mindestens ein mal die Fakturierung versucht wurde, kommt nicht in die Avisierung.</p>
<p>Die folgende Prozedur zeigt den Ablauf der Faktura- und Avis-Jobs. Die Beschreibung betrachtet die Bearbeitung eines Auftrags.</p>
<p><strong>Prozedur 15. Faktura- oder Avisjob</strong></p>
<ol>
<li>
<p>Kann der Auftrag erledigt werden? Wenn ja, dann wird das in diesem Schritt gemacht. Wenn nein, dann geht es mit dem nächsten Schritt weiter.</p>
<p>Ein Auftrag gilt als erledigt, wenn alle Positionen geliefert oder abgesagt werden können. Abgesagt werden nur nicht-lieferbare Ausverkaufsartikel.</p>
</li>
<li>
<p>Ist der Teillieferungsschalter eingestellt? Wenn ja, versucht das System eine Teillieferung zu machen (das geht genau dann, wenn mindestens eine Position lieferbar ist). Wenn nein, geht es weiter beim nächsten Schritt.</p>
<p>Wird bei diesem Schritt eine Teillieferung durchgeführt, dann wird der Teillieferungsschalter wieder zurückgesetzt und der Prozess endet hier.</p>
</li>
<li>
<p>Aufgrund der Geduldstufe im Auftragskopf wird die Frist aus der Geduldstufen-Tabelle geholt. Ist das Auftragsalter kleiner oder gleich der Frist (d.h., die Frist ist noch nicht abgelaufen), dann endet der Prozess ohne weitere Schritte hier.</p>
<p>Wenn die Frist abgelaufen ist, dann wird die Geduldstufe im Auftrag auf die nächst höhere (aus der Geduldstufen-Tabelle) gesetzt. Dann werden die Zeilen der Geduldstufen-Tabelle in der neuen Stufe evaluiert, bis die erste passende gefunden wird. Die in der gefundenen Zeile gespeicherte Aktion wird nun ausgeführt.</p>
</li>
</ol>
<p>Die Unterschiede zwischen Avisierung und Fakturierung sind beispielsweise die folgenden. Im ersten Schritt wird der Auftrag erledigt, falls das möglich ist. Ein Fakturajob generiert dort eine Faktura. Ein Avis-Job kann keine Fakturen erzeugen, er hört aber an dieser Stelle auf, weil er weiss, dass der nächste Fakturajob den Auftrag erledigen wird.</p>
<h3 id="letzte-geduldstufe-wiederholen" tabindex="-1"><a class="header-anchor" href="#letzte-geduldstufe-wiederholen"><span>Letzte Geduldstufe wiederholen</span></a></h3>
<p>Wird im Aufbereitungsjob die Option „Letzte Geduldstufe wiederholen“ gesetzt, dann wird in <RouteLink to="/referenz/refs/ft.refproc.faktavis.html#step-geduld" title="Schritt 3">Schritt 3</RouteLink> die Frist nicht getestet, sondern es werden die Regeln der „alten “ Geduldstufe neu evaluiert.</p>
<h3 id="einfluss-der-steuercodes-auf-artikelebene" tabindex="-1"><a class="header-anchor" href="#einfluss-der-steuercodes-auf-artikelebene"><span>Einfluss der Steuercodes auf Artikelebene</span></a></h3>
<p>Die Steuercodes NAuf, NAvi und NAbs können bei einzelen Artikeln erfasst werden, um gewisse vom Avisierungssystem ausgelöste Aktionen zu verhindern.</p>
<h4 id="einfluss-von-nauf" tabindex="-1"><a class="header-anchor" href="#einfluss-von-nauf"><span>Einfluss von NAuf</span></a></h4>
<p>Wenn beim Auftrag der NAuf-Parameter für einen Artikel mit Status 1 oder 5 aktiv ist, dann wird die obige Prozedur gar nicht erst durchlaufen.</p>
<h4 id="einfluss-von-navi" tabindex="-1"><a class="header-anchor" href="#einfluss-von-navi"><span>Einfluss von NAvi</span></a></h4>
<p>Schliesst einen Auftrag aus der Avisierung aus. Der Avisierungsjob bricht einfach ab und unternimmt nichts, wenn der Auftrag einen NAvi-Artikel (mit Status 1 oder 5) besitzt.</p>
<h4 id="einfluss-von-naabs" tabindex="-1"><a class="header-anchor" href="#einfluss-von-naabs"><span>Einfluss von NAabs</span></a></h4>
<p>Bei Aktionen, welche eine Absage durchführen (AI-) oder (A-L), wird die Absage-Aktion weggelassen. Das System reagiert in diesem Fall also wie wenn in den Geduldstufen die Aktion &quot;-I-&quot; anstatt &quot;AI-&quot; resp. &quot;--L&quot; anstatt &quot;A-L&quot; aufgerufen worden wäre.</p>
<h3 id="systemverhalten-bei-fakturierung-und-avisierung" tabindex="-1"><a class="header-anchor" href="#systemverhalten-bei-fakturierung-und-avisierung"><span>Systemverhalten bei Fakturierung und Avisierung</span></a></h3>
<p>Dieser Abschnitt beschreibt, wie sich die verschidenen Aktionen in den <RouteLink to="/referenz/refs/ft.refdata.tblgeduld.html">Geduldstufen</RouteLink> bei verschiedenen Typen von Aufträgen auswirken.</p>
<p>In der nachstehenden Tabelle werden die verschiedenen Typen von Aufträgen anhand der vorhandenen Auftrags-Positionen und deren Status charakterisiert. Eine Zahl bedeutet „es hat mindestens eine Auftragsposition mit diesem Status“. Der Status 1 wird unterteilt in 1a (Ausverkaufsartikel) und 1n (normal).</p>
<p>3: Nur lieferbare Positionen</p>
<p>3,1a: Es hat lieferbare Positionen und nicht lieferbare Positionen. Die nicht lieferbaren Positionen beziehen sich alle auf Ausverkaufs-Artikel.</p>
<p>Die in der Tabelle angebebenen Aktionen beinhalten nicht alle Möglichkeiten. Andere Aktionen als die angegebenen machen aber wenig Sinn und sollten nicht verwendet werden.</p>
<p><strong>Tabelle 69. Aktionen des Avisierungs- und Fakturierungssystems</strong></p>
<table>
<thead>
<tr>
<th>Auftragstyp</th>
<th>Aktion</th>
<th>Avisierung</th>
<th>Fakturierung</th>
<th>Statusänderungen</th>
<th>Avis erzeugt?</th>
<th>Statusänderungen</th>
<th>Faktura erzeugt?</th>
</tr>
</thead>
<tbody>
<tr>
<td>3</td>
<td>-I-</td>
<td>-</td>
<td>Ja</td>
<td>3 -&gt; I</td>
<td>Ja</td>
<td></td>
<td></td>
</tr>
<tr>
<td>--L</td>
<td>-</td>
<td>-</td>
<td>3 -&gt; I</td>
<td>Ja</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>AI-</td>
<td>3 -&gt; A</td>
<td>Ja</td>
<td>3 -&gt; I</td>
<td>Ja</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>A-L</td>
<td>-</td>
<td>-</td>
<td>3 -&gt; I</td>
<td>Ja</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>3,1n</td>
<td>-I-</td>
<td>-</td>
<td>Ja</td>
<td>-</td>
<td>-</td>
<td></td>
<td></td>
</tr>
<tr>
<td>--L</td>
<td>-</td>
<td>-</td>
<td>3 -&gt; I</td>
<td>Ja</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>AI-</td>
<td>3 -&gt; A, 1n -&gt; A</td>
<td>Ja</td>
<td>-</td>
<td>-</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>A-L</td>
<td>-</td>
<td>-</td>
<td>3 -&gt; I, 1n -&gt; A</td>
<td>Ja</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>3,1a</td>
<td>-I-</td>
<td>-</td>
<td>Ja</td>
<td>3 -&gt; I, 1a -&gt; A</td>
<td>Ja</td>
<td></td>
<td></td>
</tr>
<tr>
<td>--L</td>
<td>-</td>
<td>-</td>
<td>3 -&gt; I, 1a -&gt; A</td>
<td>Ja</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>AI-</td>
<td>3 -&gt; A, 1a -&gt; A</td>
<td>Ja</td>
<td>3 -&gt; I, 1a -&gt; A</td>
<td>Ja</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>A-L</td>
<td>-</td>
<td>-</td>
<td>3 -&gt; I, 1a -&gt; A</td>
<td>Ja</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>3,1a,1n</td>
<td>-I-</td>
<td>-</td>
<td>Ja</td>
<td>-</td>
<td>-</td>
<td></td>
<td></td>
</tr>
<tr>
<td>--L</td>
<td>-</td>
<td>-</td>
<td>3 -&gt; I, 1a -&gt; A</td>
<td>Ja</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>AI-</td>
<td>3 -&gt; A, 1a -&gt; A, 1n -&gt; A</td>
<td>Ja</td>
<td>-</td>
<td>-</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>A-L</td>
<td>-</td>
<td>-</td>
<td>3 -&gt; I, 1a -&gt; A, 1n -&gt; A</td>
<td>Ja</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>1n</td>
<td>-I-</td>
<td>-</td>
<td>Ja</td>
<td>-</td>
<td>-</td>
<td></td>
<td></td>
</tr>
<tr>
<td>--L</td>
<td>-</td>
<td>-</td>
<td>-</td>
<td>-</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>AI-</td>
<td>1n -&gt; A</td>
<td>Ja</td>
<td>-</td>
<td>-</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>A-L</td>
<td>-</td>
<td>-</td>
<td>-</td>
<td>-</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>1a</td>
<td>-I-</td>
<td>-</td>
<td>Ja</td>
<td>1a -&gt; A</td>
<td>-</td>
<td></td>
<td></td>
</tr>
<tr>
<td>--L</td>
<td>-</td>
<td>-</td>
<td>1a -&gt; A</td>
<td>-</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>AI-</td>
<td>1a -&gt; A</td>
<td>Ja</td>
<td>1a -&gt; A</td>
<td>-</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>A-L</td>
<td>-</td>
<td>-</td>
<td>1a -&gt; A</td>
<td>-</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>1n,1a</td>
<td>-I-</td>
<td>-</td>
<td>Ja</td>
<td>-</td>
<td>-</td>
<td></td>
<td></td>
</tr>
<tr>
<td>--L</td>
<td>-</td>
<td>-</td>
<td>1a -&gt; A</td>
<td>-</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>AI-</td>
<td>1n -&gt; A, 1a -&gt; A</td>
<td>Ja</td>
<td>-</td>
<td>-</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>A-L</td>
<td>-</td>
<td>-</td>
<td>1n -&gt; A, 1a -&gt; A</td>
<td>-</td>
<td></td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Aufträge: → Verarbeitungsläufe → Fakturen/Avis verarbeiten → Fakturen/Avis aufbereiten → Menü: Aufbereiten</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>von Datum/Jobnummer / bis Datum/Jobnummer</dt>
<dd>Angabe eines Bereichs von Jobs (von/bis)</dd>
<dt>nicht-fakturierbare Aufträge auflisten</dt>
<dd>Listet die nicht fakturierbaren Aufträge auf dem Protokoll mit der Angabe von Gründen, aus.</dd>
<dt>Ausgabe</dt>
<dd>Standard</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/avisierungssystem.html" title="2. Avisierungssystem">Avisierung</RouteLink></p>
</div></template>


